"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inDOM = !!(typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/dom-helpers/util/in-dom.js
// module id = 67
// module chunks = 0 1 2 3 4 5 6